// 导出SKU与外部条码绑定
export const exportBarCode = params => {
  return window._this.$http.post(`/erp/StorageSurplus/exportBarCode`, params);
};



// WEBPACK FOOTER //
// ./src/api/inventoryProfit.js